import { styled } from 'styled-system/jsx'

const Hero = styled('section', {
  base: {
    paddingY: { base: '64px', md: '88px' },
    paddingX: { base: '16px', md: '32px' },
    background:
      'linear-gradient(180deg, var(--colors-book-primarySoft) 0%, var(--colors-book-surface) 100%)',
  },
})

const HeroInner = styled('div', {
  base: {
    maxWidth: '880px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
})

const HeroEyebrow = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: 600,
    color: 'book.primary',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
  },
})

const HeroHeadline = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: { base: '36px', md: '52px' },
    fontWeight: 700,
    lineHeight: 1.05,
    letterSpacing: '-0.02em',
    color: 'app.fg',
    margin: 0,
  },
})

const HeroSubhead = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: { base: '17px', md: '19px' },
    lineHeight: 1.55,
    color: 'app.fgMuted',
    maxWidth: '640px',
    margin: 0,
  },
})

const CasesSection = styled('section', {
  base: {
    paddingY: { base: '64px', md: '96px' },
    paddingX: { base: '16px', md: '32px' },
    backgroundColor: 'app.surface',
  },
})

const CasesInner = styled('div', {
  base: {
    maxWidth: '1180px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: { base: '1fr', md: 'repeat(2, 1fr)' },
    gap: { base: '20px', md: '24px' },
  },
})

const CaseCard = styled('article', {
  base: {
    backgroundColor: 'app.surface',
    border: '1px solid',
    borderColor: 'app.border',
    borderRadius: 'lg',
    padding: { base: '28px', md: '32px' },
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    transition: 'border-color 200ms, box-shadow 200ms',
    _hover: {
      borderColor: 'book.borderStrong',
      boxShadow:
        '0 1px 2px rgba(15, 23, 42, 0.04), 0 12px 24px rgba(15, 23, 42, 0.06)',
    },
  },
})

const CaseHead = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
  },
})

const CaseTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: { base: '22px', md: '26px' },
    fontWeight: 700,
    color: 'app.fg',
    margin: 0,
    lineHeight: 1.15,
    letterSpacing: '-0.01em',
  },
})

const CaseBody = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15.5px',
    lineHeight: 1.55,
    color: 'app.fgMuted',
    margin: 0,
  },
})

const ExamplesLabel = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: 600,
    color: 'app.fgMuted',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    marginTop: '4px',
  },
})

const ExamplesList = styled('ul', {
  base: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
})

const ExampleItem = styled('li', {
  base: {
    fontFamily: 'body',
    fontSize: '14.5px',
    lineHeight: 1.5,
    color: 'app.fg',
    paddingLeft: '22px',
    position: 'relative',
    _before: {
      content: '"→"',
      position: 'absolute',
      left: 0,
      top: 0,
      color: 'book.primary',
      fontWeight: 600,
    },
  },
})

export {
  Hero,
  HeroInner,
  HeroEyebrow,
  HeroHeadline,
  HeroSubhead,
  CasesSection,
  CasesInner,
  CaseCard,
  CaseHead,
  CaseTitle,
  CaseBody,
  ExamplesLabel,
  ExamplesList,
  ExampleItem,
}
